import { Alert, Col, Modal, Row, Spin, Typography } from "antd";
import { FunctionComponent, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useStateIfMounted } from "use-state-if-mounted";
import OrganizationModel from "../../../shared/organization-model";
import OrganizationForm from "../../components/organization-form";
import HttpClient from "../../http-client";

interface OrganizationUpdatePageProps {}

const OrganizationUpdatePage: FunctionComponent<
  OrganizationUpdatePageProps
> = () => {
  const [data, setData] = useStateIfMounted<OrganizationModel | undefined>(
    undefined
  );
  const [loading, setLoading] = useStateIfMounted(false);
  const { id } = useParams();
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await HttpClient.get(`organization/info`);

        if (data?.data) {
          setData(data.data);
        } else {
          throw new Error("Organization not found");
        }
      } catch (e) {
        console.log(e);
        Modal.error({ content: "Organization not found", title: "Ops!" });
      }
      setLoading(false);
    })();
  }, [id]);
  return (
    <Row>
      <Col span={20}>
        <Typography.Title level={4}>Update Organization</Typography.Title>
        {loading ? (
          <Spin />
        ) : data ? (
          <OrganizationForm
            httpClient={HttpClient}
            initialValue={data}
            onUpdate={(data) => {
              setData(data);
              // reload the page
              window.location.reload();
            }}
          />
        ) : (
          <Alert message="Unable to load organization" type="error" />
        )}
      </Col>
    </Row>
  );
};

export default OrganizationUpdatePage;
